import { GlobalPartnerContentTypes } from './models'

export const CONTENT_TYPE_OPTIONS = [
  GlobalPartnerContentTypes.BasicInfo,
  GlobalPartnerContentTypes.List,
  GlobalPartnerContentTypes.EntityManagement,
  // GlobalPartnerContentTypes.Map,
  // GlobalPartnerContentTypes.Diagram,
]
